import { getToken } from 'nostr-tools/nip98';
import type { SignerConnection } from './signers';
import { createSession, type Organization } from './api';

export async function authenticate(connection: SignerConnection, signal?: AbortSignal): Promise<Organization> {
  const endpoint = new URL('/api/auth/session', window.location.origin).toString();
	const token = connection.authenticationToken ?? await getToken(endpoint, 'POST', (event) => connection.signer.signEvent(event), true);
  signal?.throwIfAborted();
  const organization = await createSession(token, signal);
  if (organization.pubkey !== connection.pubkey) {
    throw new Error('The authenticated organization does not match the connected signer.');
  }
  return organization;
}
